module.exports = __webpack_public_path__ + "img/LIST.605aa23b.svg";